if (typeof JW === 'undefined') JW = {};
JW.GeoC = (function ($)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'GEOC';
    _pri.opts = {                       // options for various object initializations
        dbg_lvl: 1,                     // debug level
        atk: '',                        // mapbox accesToken for geocoding and map tiles
        query_rxp: /\{QUERY\}/,
        abbr_street_rxp: /str\.\s*$/i,
        url: 'https://api.mapbox.com/geocoding/v5/mapbox.places/{QUERY}.json?access_token=',
        gll_ajx: {                      // free locate ip service ... 10000 an hour ...
            type: "GET",
            url: '/_gll',
            data: {},
            dataType: 'json'
        }

    };

    _pri.loc_cache      = {};
    _pri.addr_cache     = {};
    _pri.addr_hash_last = '';

    _pri.inited = false;
    _pri.page = null;
    _pri.t_get_name = 0;
    _pri.omit_locate = false;


    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    publ.init = function()
    {
        _pri.dbgG('*** init() (jsadd)');

        if (_pri.inited)
        {
            _pri.dbg('    !!! already inited!');
            return;
        }

        _pri.inited = true;

        _pri.page = JW.Page;
        _pri.rx_postcode = new RegExp('^postcode\.');

        var uarx = /Googlebot|Storebot|InspectionTool|GoogleOther|Google-Extended|Mediapartners-Google|AdsBot-Google|APIs-Google|Google-Safety|Google Search Console|Google Page Speed|FeedFetcher-Google|GoogleProducer|Google-Read|Google-Site/i;
        if (uarx.test(navigator.userAgent))
        {
            _pri.omit_locate = true;
        }
        //_pri.dbg('_pri.omit_locate? ', _pri.omit_locate);

        _pri.initOpts();
        // _pri.initMapFormWidget();
    };

    publ.getAddressToLL = function(ll)
    {
        _pri.dbg('******** getAddressToLL()');
        var t = $.now();
        if (_pri.t_get_name + 1000 > t)
        {
            _pri.dbg('        left out ...');
            return;
        }
        _pri.t_get_name = t;

        _pri.page.trigger('geoc:get_address_to_ll', {addr: {}, ll: ll});
        var types_str = 'address';
        var uquery = encodeURIComponent(ll.lng + ',' + ll.lat);
        $.get(_pri.getQueryUrl(uquery, ('&types=' + types_str))).done(function(ret) {
            _pri.dbg('******** getAddressToLL done()');
            _pri.dbg('ret', ret);
            _pri.dbg('uquery', uquery);
            if (ret && typeof ret == 'object' && $.isArray(ret.features) && ret.features.length > 0)
            {
                _pri.page.trigger('geoc:get_address_to_ll_done', {addr: ret.features[0], ll: ll});
            }
            else
            {
                _pri.page.trigger('geoc:get_address_to_ll_err', {addr: {}, ll: ll});
            }
        });

    };

    _pri.getAddrStr = function(o)
    {
        // should return sth. like 'Brennerstraße 1, Hamburg 20099'
        var str = '';
        var parts = [];

        if (o.hasOwnProperty('street'))
        {
            str = o.street;
            _pri.dbg('street: ', str);
            str = str.replace(_pri.opts.abbr_street_rxp, 'strasse');
            // strange - space is needed here, even if no number will be appended
            str += ' ';
            _pri.dbg('street: ', str);
            if (o.hasOwnProperty('street_no'))
            {
                str += o.street_no;
            }
            parts.push(str);
            str = '';
        }

        if (o.hasOwnProperty('city'))
        {
            str = o.city;
        }
        if (o.hasOwnProperty('zip'))
        {
            if (str != '')
            {
                str += ' ';
            }
            str += o.zip;
        }
        if (str != '')
        {
            parts.push(str);
            str = '';
        }

        return parts.join(',');
    };

    _pri.getAddrHash = function(addr)
    {
        var i;
        var ks = Object.keys(addr).sort();
        var len = ks.length;
        var parts = [];

        for (i = 0; i < len; ++i)
        {
            parts.push(addr[ks[i]]);
        }

        return parts.join(',').getHash();
    };

    publ.getLLToAddress = function(addr)
    {
        _pri.dbg('******** getLLToAddress()');

        _pri.page.trigger('geoc:get_ll_to_address', {addr: addr, ll: null});

        var nm = _pri.getAddrStr(addr);

        if (nm.length > 512)
        {
            nm = nm.substr(0, 512);
            _pri.dbg('    cropped to ' + nm);
        }
        unm = encodeURIComponent(nm);

        var addr_hash = _pri.getAddrHash(addr);

        if (_pri.addr_cache.hasOwnProperty(addr_hash))
        {
            _pri.dbg('    CACHED ... hash:', addr_hash);
            var o = _pri.addr_cache[addr_hash];
            var lat = o.geometry.coordinates[1],
                lng = o.geometry.coordinates[0];

            _pri.page.trigger('geoc:get_ll_to_address_done', {addr: addr, ll: L.latLng(lat, lng)});
        }
        else
        {
            var add_params = '&types=address'; //country,region,postcode,place';
            if (addr.hasOwnProperty('cc'))
            {
                add_params += ('&country=' + addr.cc.toLowerCase());
            }
            else
            {
                add_params += '&country=de';
            }
            $.get(_pri.getQueryUrl(unm, add_params)).done(function(ret) {
                _pri.dbg('******** getLLToAddress done()');
                _pri.dbg('ret', ret);
                _pri.dbg('unm', unm);
                if (ret && typeof ret == 'object' && $.isArray(ret.features) && ret.features.length > 0)
                {
                    // we'll simply use the first one cause country has been set by params ...
                    // maybe we should cycle through to sort by relevance?
                    // but i guess it already has been sorted by relevance ... will be checked - later ;-)
                    var lat = ret.features[0].geometry.coordinates[1],
                        lng = ret.features[0].geometry.coordinates[0];
                    _pri.page.trigger('geoc:get_ll_to_address_done', {addr: addr, ll: L.latLng(lat, lng)});
                    _pri.addr_cache[addr_hash] = ret.features[0];
                }
                else
                {
                    _pri.page.trigger('geoc:get_ll_to_address_err', {addr: addr, ll: null});
                }
            });
        }
    };

    // simple names

    publ.getNameToLL = function(ll)
    {
        _pri.dbg('******** getNameToLL()');

        var t = $.now();
        /*
         * commented to prevent sform states with empty ql
         *
        if (_pri.t_get_name + 1000 > t)
        {
            return;
        }
        */
        _pri.t_get_name = t;


        _pri.page.trigger('geoc:set_name_to_ll', {nm: '', ll: ll});

        let llr       = _pri.roundLL(ll, 5);
        // var types_str = 'country,region,postcode,place';
        let types_str = 'place,postcode';
        let uquery    = encodeURIComponent(llr.lng + ',' + llr.lat);

        $.get(_pri.getQueryUrl(uquery, ('&types=' + types_str))).done(function(ret) {
            _pri.dbgG('*** getNameToLL done()');
            _pri.dbg('    ret', ret);
            _pri.dbg('    ret.features', ret.features);
            _pri.dbg('    uquery', uquery);

            if (ret && typeof ret == 'object' && $.isArray(ret.features) && ret.features.length > 0)
            {
                //_pri.dbg('       * ', ret.features[0]);
                // _pri.page.trigger('geoc:set_name_to_ll_done', {nm: ret.features[0].text, ll: ll});

                let ftr = null;
                $.each(ret.features, function(k, v) {
                    if (_pri.rx_postcode.test(v.id))
                    {
                        _pri.dbgY('    postcode found!');
                        ftr = v;
                    }
                });

                if (!_pri.isObj(ftr))
                {
                    _pri.dbgY('    postcode NOT found!');
                    ftr = ret.features[0];
                }

                let nm;
                if (_pri.rx_postcode.test(ftr.id))
                {
                    let nm_arr = ftr.place_name.split(',').slice(0, 2);
                    nm = nm_arr.join('');
                }
                else
                {
                    nm = ftr.text;
                }

                _pri.page.trigger('geoc:set_name_to_ll_done', {nm: nm, ll: ll});
            }
            else
            {
                _pri.page.trigger('geoc:set_name_to_ll_err', {nm: '', ll: ll});
            }
        });
    };

    publ.getLLToName = function(nm, callid)
    {
        _pri.dbg('******** getLLToName()');

        _pri.page.trigger('geoc:set_ll_to_name', {nm: nm, ll: null});

        if (nm.length > 128)
        {
            nm = nm.substr(0, 128);
            _pri.dbg('    cropped to ' + nm);
        }
        unm = encodeURIComponent(nm);

        if (typeof callid !== 'string')
        {
            callid = '';
        }

        if (_pri.loc_cache.hasOwnProperty(unm))
        {
            _pri.dbg('    CACHED ...');
            var o = _pri.loc_cache[unm];
            var lat = o.geometry.coordinates[1],
                lng = o.geometry.coordinates[0];
            //XXX_pri.setCircleSearch(L.latLng(lat, lng));
            _pri.page.trigger('geoc:set_ll_to_name_done', {nm: nm, ll: L.latLng(lat, lng), callid: callid});
        }
        else
        {
            // country: comma separated list, switch programmatically if needed
            // added poi - lets see ...
            var add_params = '&country=de&types=country,region,postcode,place,poi';
            if (JW.Page.hasMap())
            {
                var ll = JW.Map.getMapCenter();
                if (ll)
                {
                    ll = _pri.roundLL(ll, 5);
                    add_params += '&proximity=' + ll.lng + ',' + ll.lat;
                }
            }

            $.get(_pri.getQueryUrl(unm, add_params)).done(function(ret) {
                _pri.dbgG('*** getLLToName done()');
                _pri.dbg('    ret', ret);
                _pri.dbg('    unm', unm);
                if (ret && typeof ret == 'object' && $.isArray(ret.features) && ret.features.length > 0)
                {
                    // we'll use the first german one or simply the first if no german place has been found ... for now
                    var len = ret.features.length;
                    var ix = -1, i, j, len2, f;
                    /*
                    var lat = ret.features[0].geometry.coordinates[1],
                        lng = ret.features[0].geometry.coordinates[0];
                    _pri.setCircleSearch(L.latLng(lat, lng));
                    _pri.loc_cache[unm] = ret.features[0];
                    */
                    loop_feature:
                    for (i = 0; i < len; ++i)
                    {
                        f = ret.features[i];
                        if (typeof f === 'object' && f.context && $.isArray(f.context) && f.context.length > 0)
                        {
                            len2 =  f.context.length;
                            for (j = 0; j < len2; ++j)
                            {
                                if (typeof f.context[j] === 'object' && f.context[j].short_code && f.context[j].short_code == 'de')
                                {
                                    // if (f.id.lastIndexOf('place.', 0) === 0)
                                    if (f.id.lastIndexOf('postcode.', 0) === 0)
                                    {
                                        _pri.dbg('        postcode MATCHED');
                                        ix = i;
                                        break loop_feature;
                                    }
                                    else if (ix == -1)
                                    {
                                        ix = i;
                                    }
                                }
                            }
                        }
                    }
                    // we did not found what we'd expected - so lets take first
                    if (ix == -1)
                    {
                        ix = 0;
                    }
                    var lat = ret.features[ix].geometry.coordinates[1],
                        lng = ret.features[ix].geometry.coordinates[0];
                    //XXX_pri.setCircleSearch(L.latLng(lat, lng));
                    // or set nm to corrected name: ret.features[ix].text ???
                    _pri.page.trigger('geoc:set_ll_to_name_done', {nm: nm, ll: L.latLng(lat, lng), callid: callid});
                    _pri.loc_cache[unm] = ret.features[ix];
                }
                else
                {
                    _pri.page.trigger('geoc:set_ll_to_name_err', {nm: nm, ll: null, callid: callid});
                }
            });
        }
    };

    _pri.getQueryUrl = function(query, qery_params_str)
    {
//         _pri.dbg('*** getQueryUrl()');
//         _pri.dbg('    query: ', query, 'qery_params_str: ', qery_params_str);
//         _pri.dbg('    url: ', _pri.opts.url.replace(_pri.opts.query_rxp, query) + qery_params_str);
        return _pri.opts.url.replace(_pri.opts.query_rxp, query) + qery_params_str;
    };

// ################################################################
// ################################################################
//         Locate
// ################################################################
// ################################################################


    publ.locate = function(e)
    {
        _pri.dbgG('*** locate()');
        /*
        // as long as only HH has employers ...
        if (!e || typeof e !== 'object' || typeof e.preventDefault === 'undefined')
        {
            _pri.dbg('    no event - use HH');
            var ll = L.latLng(53.55, 10.0167);
            if (_pri.page.isPhoneMode() && _pri.isObj(JW.MapSForm))
            {
                JW.MapSForm.ffxClick('#col-map');
            }
            _pri.page.trigger('geoc:set_ll_to_name_done', {nm: '', ll: L.latLng(53.55, 10.0167)}); // dunno if there was a reason to create extra object for event ...
            publ.getNameToLL(ll);

            return false;
        }
        */

        if (e && typeof e === 'object' && typeof e.preventDefault !== 'undefined')
        {
            e.preventDefault();
        }

//         _pri.dbg('navigator.geolocation', typeof navigator.geolocation);
//         _pri.dbg('navigator.geolocation.getCurrentPosition', typeof navigator.geolocation.getCurrentPosition);

        if (!_pri.omit_locate && typeof navigator.geolocation === 'object' && typeof navigator.geolocation.getCurrentPosition === 'function')
        {
            navigator.geolocation.getCurrentPosition(_pri.onLocateSucc, _pri.onLocateErr, _pri.opts.locate);
        }
        else
        {
            _pri.onLocateErr({ code: 888, message: "Geolocation services are not supported by your web browser." });
        }

        return false;
    };


    _pri.onLocateSucc = function(pos)
    {
        _pri.dbgG('*** onLocateSucc()');
        _pri.dbg(pos);

        var lat  = pos.coords.latitude;
        var lng  = pos.coords.longitude;
        //var alt  = pos.coords.altitude;
        //var acc  = pos.coords.accuracy;
        var ll = L.latLng(lat, lng);

        /*
        localStorage.setItem("user_lat", lat);
        localStorage.setItem("user_lng", lng);
        */
        if (_pri.page.isPhoneMode() && _pri.isObj(JW.MapSForm))
        {
            JW.MapSForm.ffxClick('#col-map');
        }
        _pri.page.trigger('geoc:set_ll_to_name_done', {nm: '', ll: L.latLng(lat, lng)});
        publ.getNameToLL(ll);
    };

    _pri.onLocateErr = function(err)
    {
        _pri.dbg('******** onLocateErr()');
        _pri.dbg(err);

        $.ajax(_pri.opts.gll_ajx).done(function(ret, stat_str, jq_xhr) {
            //_pri.dbg('         ret: ', ret, ' | stat_str: ', stat_str, ' | jq_xhr: ', jq_xhr);
            if ( stat_str == 'success' && typeof ret == 'object' && ret.hasOwnProperty('errno') && ret.errno == 0
                && ret.hasOwnProperty('lat') && ret.lat != 0 && ret.hasOwnProperty('lng') && ret.lng != 0 )
            {
                var ll = L.latLng(ret.lat, ret.lng);

                if (_pri.page.isPhoneMode() && _pri.isObj(JW.MapSForm))
                {
                    JW.MapSForm.ffxClick('#col-map');
                }
                _pri.page.trigger('geoc:set_ll_to_name_done', {nm: '', ll: L.latLng(ret.lat, ret.lng)});
                publ.getNameToLL(ll);
            }
            else
            {
                var ll = L.latLng(53.55, 10.0167);
                if (_pri.page.isPhoneMode() && _pri.isObj(JW.MapSForm))
                {
                    JW.MapSForm.ffxClick('#col-map');
                }
                _pri.page.trigger('geoc:set_ll_to_name_done', {nm: '', ll: L.latLng(53.55, 10.0167)}); // dunno if there was a reason to create extra object for event ...
                publ.getNameToLL(ll);
            }
        });
    };



    _pri.initOpts = function()
    {
        _pri.opts.atk = JW.Page.getATk();
        _pri.opts.url += _pri.opts.atk;
        _pri.opts.locate = {
            enableHighAccuracy: true,
            maximumAge: 30000,
            timeout: 3000
        };
    };

    // _pri.initMapFormWidget = function()
    // {
    //     var $frm = $('form.mapwidgetform');
    //     if ($frm.length > 0)
    //     {
    //         JW.Mapform(jQuery, $frm[0]);
    //     }
    // };



    _pri.extend();

    // expose public methods
    return publ;
})(jQuery);
